import { processInclude } from './util/common';
import Product, { crossSellItems, youMayAlsoLikeItems, computeCurrentlyVisibleImage } from './product/detail';
import Klarna from 'product/klarna';
import { newModalFromString, newModalFromSelector } from './components/modal';
import ScalaPay from 'product/scalaPay';
import QuickView from './product/quickView';
import { initColorSlickCarousel, modalQuickAdd } from './quickAdd';

var slideIndex = 0;
class AccordionOpener {
    init() {
        $(document).on('click', '.js-panel-opener', (evt) => {
            evt.stopPropagation();
            if ($('.clicked-size').length > 0) {
                $('.add-to-cart-mobile').prop('disabled', true);
            }
            $('.add-mobile-soldout-add').prop('disabled', true);
            const $allOpenPanels = $('[data-opener].open');

            const target = evt.currentTarget;
            var $panelToOpen = $('[data-attr="' + target.dataset.opener + '"] .js-panel').eq(0);

            if (evt.currentTarget.dataset.index) {
                if ($('[data-attr="' + target.dataset.opener + '"] .js-panel').eq(evt.currentTarget.dataset.index).length > 0) {
                    $panelToOpen = $('[data-attr="' + target.dataset.opener + '"] .js-panel').eq(evt.currentTarget.dataset.index);
                } else {
                    $panelToOpen = $('[data-attr="' + target.dataset.opener + '"] .js-panel').eq(0);
                }
            }

            // open correct panel
            if ($panelToOpen.hasClass('hidden')) {
                target.classList.add('open');
                $('.fab#esw-fab').addClass('ui-eswback');
                $panelToOpen.removeClass('hidden');
                if ($('.product-wrapper--tezenis').length) {
                    $('.veil').addClass('show');
                    $('.triangle-down.caret').addClass('rotate');
                }
            } else {
                $('.js-panel-opener').parent().removeClass('inactive-logic');
                target.classList.remove('open');
                $('.fab#esw-fab').removeClass('ui-eswback');
                $panelToOpen.addClass('hidden');
                if ($('.product-wrapper--tezenis').length) {
                    $('.veil').removeClass('show');
                    $('.triangle-down.caret').removeClass('rotate');
                }
            }

            $(document).on('click', '.close-mobile-color', function () {
                if ($('.product-wrapper--tezenis').length) {
                    $(`.descriptionSidebar--tezenis .descriptionSidebar__details .js-panel-opener:eq(${$(this).data('index')})`).trigger('click');
                }
                $('.add-to-cart-mobile').prop('disabled', false);
                $('.add-mobile-soldout-add').prop('disabled', false);
            });

            // close all other previously open panels
            for (let k of $allOpenPanels) {
                k.classList.remove('open');
                const relatedPanel = k.dataset.opener;
                const $panelToClose = $('[data-attr="' + relatedPanel + '"] .js-panel');
                $panelToClose.addClass('hidden');
            }
        }).on('click', (evt) => {
            const clickedOutside = $(evt.target).closest('.js-panel').length === 0;
            if (clickedOutside) {
                $('.pdpCarousel__slider-container .veil').removeClass('show');
                $('.fab#esw-fab').removeClass('ui-eswback');
                $('.add-to-cart-mobile').prop('disabled', false);
                $('.add-mobile-soldout-add').prop('disabled', false);
                const $allOpenPanels = $('[data-opener].open');
                $('.js-panel-opener').parent().removeClass('inactive-logic');
                for (let k of $allOpenPanels) {
                    const relatedPanel = k.dataset.opener;
                    k.classList.remove('open');
                    const $panelToClose = $('[data-attr="' + relatedPanel + '"] .js-panel');
                    $panelToClose.addClass('hidden');
                }
            }
        }).on('product:afterAttributeSelect', (evt, data) => {
            const $allOpenPanels = $('[data-opener].open');
            $('.js-panel-opener').parent().removeClass('inactive-logic');
            for (let k of $allOpenPanels) {
                const relatedPanel = k.dataset.opener;
                if (relatedPanel !== 'QNT') {
                    k.classList.remove('open');
                    const $panelToClose = $('[data-attr="' + relatedPanel + '"] .js-panel');
                    $panelToClose.addClass('hidden');
                }
            }
            if (data.type === 'color') {
                scrollToTop();
            }
        });
    }
}

class FixedBar {
    constructor() {
        this.ticking = false;
        this.fixedElement = '';
        this.scrollStopperElement = '';
    }

    init(fixedElement, stopperElement) {
        const fixedHTMLElement = document.getElementById(fixedElement);
        if (!fixedHTMLElement) {
            return;
        }

        const computedPosition = window.getComputedStyle(fixedHTMLElement).position;
        if (computedPosition === 'sticky') {
            $(fixedHTMLElement).unwrap();
            return;
        }

        fixedHTMLElement.style.position = 'fixed';
        fixedHTMLElement.style.top = null;
        fixedHTMLElement.style.width = fixedHTMLElement.parentNode.clientWidth + 'px';
        fixedHTMLElement.style.marginLeft = '0px';

        this.fixedElement = fixedElement;
        this.scrollStopperElement = stopperElement;

        window.addEventListener('scroll', this.onScroll.bind(this));
    }

    onScroll() {
        this.requestTick();
    }

    update() {
        this.ticking = false;

        const sidebar = document.getElementById(this.fixedElement);
        const stopper = document.getElementById(this.scrollStopperElement);

        sidebar.style.position = 'fixed';
        sidebar.style.bottom = null;
        sidebar.style.marginLeft = '0';

        const r1 = sidebar.getBoundingClientRect();
        const r2 = stopper.getBoundingClientRect();

        // Revert only for World Website
        if ($('.product-detail-world').length > 0 && r1.bottom > r2.top) {
            sidebar.style.position = 'relative';
            sidebar.style.bottom = '0';
            sidebar.style.top = 'auto';
            sidebar.style.left = null;
            sidebar.style.marginLeft = null;
            sidebar.style.marginLeft = '-9px';
        }
    }

    requestTick() {
        if (!this.ticking) {
            window.raf(this.update.bind(this));
        }
        this.ticking = true;
    }
}

const fixedBar = new FixedBar();
const accordion = new AccordionOpener();

function scrollToTop() {
    if (Foundation.MediaQuery.atLeast('medium')) {
        return;
    }
};

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./findYourSize/findYourSize'));
    Product.run();
    QuickView.observeQuickBuy();
    Klarna.loadKlarnaWidgetAndObservers();
    if (Foundation.MediaQuery.current === 'small') {
        initColorSlickCarousel();
    }
    fixedBar.init('.primary-images', 'bottomSpacer');
    accordion.init();
    if ($('.page').data('action').indexOf('Checkout') === -1 && $('.page').data('action').indexOf('Cart') === -1) {
        ScalaPay.run();
    }

    crossSellItems(decodeURIComponent($('.container').data('pid')));
    youMayAlsoLikeItems(decodeURIComponent($('.container').data('pid')));
    computeCurrentlyVisibleImage();

    window.addEventListener('scroll', computeCurrentlyVisibleImage.bind(this));
    updateStickyTop();

    let timer;
    let previousPosition = 0;

    const headerHeight = $('.main-header').outerHeight();

    $('body').on('click', '.js-size-not-select', (e) => {
        e.preventDefault();

        if (Foundation.MediaQuery.current === 'small') {
            return;
        }

        if ($('span.size-not-selected-label').css('display') === 'block') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    });

    $('body').on('click', '.js-det-clicker', (e) => {
        e.preventDefault();
        $('.js-det > div').toggleClass('hidden');
        $('.js-desc > div').addClass('hidden');
        $('body').trigger('product:moreInfoToggle', 'composition_and_care');
    });

    $('body').on('click', '.js-desc-clicker', (e) => {
        e.preventDefault();
        $('.js-desc > div').toggleClass('hidden');
        $('.js-det > div').addClass('hidden');
        $('body').trigger('product:moreInfoToggle', 'description');
    });

    $('body').on('click', '.js-open-find-your-size-tool', function (e) {
        e.preventDefault();
        var tabContent = $('.js-content-findYourSize-tool').html();
        const htmlContent = $('.js-modal-findYourSize-tool').html();
        const modal = newModalFromString(htmlContent, false);
        modal.open();
        modal.setContent(tabContent);
        $('.wrongSize').addClass('hidden');
        $('.your-size-result').addClass('hidden');
        $('.tingle-modal-box').addClass('modal-box-findYourSize-tool');

        var $range = $('.range');

        $range.each(function () {
            var $thumb = $(this).next('.range-thumb');
            var min = parseInt(this.min, 10);
            var max = parseInt(this.max, 10);
            var tw = 70;
            $thumb.attr('data-val', min);

            $(this).on('input input.range', function () {
                var w = $(this).width();
                var val = parseInt(this.value, 10);
                var xPX = (val - min) * (w - tw) / (max - min);
                $thumb.css({ left: xPX }).attr('data-val', val);
            });
        });

        $(modal.modalBox)
            .find('.close-button')
            .on('click', function (e) {
                modal.close();
            });

        $('.js-inside-close-modal').on('click', function (e) {
            e.preventDefault();
            modal.close();
        });

        $('[data-dismiss="modal"]').on('click', function (e) {
            e.preventDefault();
            modal.close();
        });
        $('.find-your-size-event').on('click', function (e) {
            let category = $('.analytics.product').data('category');
            $('body').trigger('product:openSizeGuide', { category: category });
        });
    });

    $('body').on('click', '.js-tingle-modal-title', function (e) {
        e.preventDefault();
        const $trigger = $(this);
        const $wrapper = $trigger.closest('.tingle-modal-wrapper');
        const analyticsInfo = $wrapper.data('analytics-info');
        if (analyticsInfo) {
            $('body').trigger('product:moreInfoToggle', analyticsInfo);
        }
        const tabContent = $trigger.siblings($('.item-description')).html();
        const modal = newModalFromString(tabContent, false, ['pdp-info-tingle-modal', 'rightModalAttribute']);

        modal.open();
        modal.setContent(tabContent);

        if ($trigger.find('.js-delivery-return').length > 0) {
            $(modal.modalBox).addClass('delivery-and-return-modal');
        }

        const titleText = $trigger.text().trim();
        const modalHeaderHTML = `
            <div class="tingle-modal-box__header">
                <button type="button" class="close-button tingle-modal-box__back-button" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
                <h4 class="tingle-modal-box__header-title">${titleText}</h4>
            </div>`;

        $(modal.modalBox).prepend(modalHeaderHTML);

        $(modal.modalBox).on('click', '.close-button', function (e) {
            e.preventDefault();
            modal.close();
        });

        const $tingleContainerOnly = $('.js-composition-info').filter(function () {
            return $(this).closest('.tingle-modal-box');
        });
        const $materialSection = $tingleContainerOnly.find('.comp-material').parent();
        const $washSection = $tingleContainerOnly.find('.icon-wash-wrapper')
        var sectionAdded = false;

        const washSectionLabel = document.getElementById('washLabelDetails').dataset.labelDetails;
        const materialSectionLabel = document.getElementById('materialLabelDetails').dataset.labelDetails;

        const spanWash = $('<h4>', {
            text: washSectionLabel,
            class: 'tingle-modal-box__title'
        });

        const spanMaterial = $('<h4>', {
            text: materialSectionLabel,
            class: 'tingle-modal-box__title'
        });

        var sectionAdded = false;

        if ($washSection.length) {
            if ($washSection.find('.tingle-modal-box__title').length === 0) {
                $washSection.prepend(spanWash);
            }
            sectionAdded = true;
        }

        if ($materialSection.length) {
            if ($materialSection.find('.tingle-modal-box__title').length === 0) {
                $materialSection.prepend(spanMaterial);
            }
            sectionAdded = true;
        }

        if (!sectionAdded) {
            return
        }
    });

    $(function () {
        const text = $('.js-product-description-text');
        const originalHTML = text.html();
        const seeMoreButton = $('.js-toggle-button');
        const seeMoreExpand = $('.js-toggle-button-more');
        const seeMoreCollapse = $('.js-toggle-button-less');
        let isExpanded = false;
        if (originalHTML) {
            const collapsedHtml = originalHTML.replace(/(<br\s*\/?>\s*){2,}/gi, "<p></p>");
            text.html(collapsedHtml);
        }

        const lineHeight = parseFloat(text.css('line-height'));
        const maxLines = 3;
        const maxHeight = lineHeight * maxLines;
        const fullHeight = text.prop('scrollHeight');

        if (fullHeight > maxHeight) {
            text.addClass('is-collapsed');
            seeMoreExpand.show();
        } else {
            seeMoreExpand.hide();
        }

        seeMoreButton.on('click', function () {
            if (!isExpanded) {
                text.removeClass('is-collapsed').addClass('is-expanded');
                seeMoreExpand.hide();
                seeMoreCollapse.show();
            } else {
                text.removeClass('expanded');
                text.removeClass('is-expanded').addClass('is-collapsed');
                seeMoreExpand.show();
                seeMoreCollapse.hide();
            }
            isExpanded = !isExpanded;
        });
    });

    /*
     * Logic to show/hide the various bars on scroll:
     * - at page top: show both header and service menu
     * - when scrolling up: show only service menu
     * - when scrolling down: do not show anything
     * This logic must not be applied when the scroll is automatic
     */
    const onScrollFunction = function () {
        const scrollYPos = window.scrollY;
        const $serviceMenu = $('header.main-header--tezenis');
        const addToCartCTA = $('.add-to-cart-actions .add-to-cart-container');
        const addToCartCTANotInViewport = '-' + $(addToCartCTA).height();
        const addToCartStickyBar = $('.add-to-cart-sticky-bar');

        if (addToCartCTA.length > 0 && $(addToCartCTA)[0].getBoundingClientRect().top >= parseInt(addToCartCTANotInViewport)) {
            $(addToCartStickyBar).css({ 'bottom': '0', 'transition': 'all 0.5s ease' });
        }

        if (scrollYPos < previousPosition) {
            $serviceMenu.css({ 'top': '0', 'transition': 'all 0.3s ease' });
            $('.js-icon-container').removeClass('at-top');
        } else if (scrollYPos > 1) {
            $serviceMenu.css({ 'top': '-' + $serviceMenu.height() + 'px', 'transition': 'all 0.3s ease' });
            $('.js-icon-container').addClass('at-top');
        }
        previousPosition = scrollYPos;
    };

    if ($('.page[data-action="Product-Show"]').length > 0 || $('.page[data-action="Search-Show"]').length > 0) {
        $('body').on('click', '.find-in-store-btn, .find-in-store-soldout', (e) => {
            e.preventDefault();
            const isSizeSelected = () => {
                if ($('.page[data-action="Search-Show"]').length > 0) {
                    return true;
                }
                return $('[data-attr="size"] input:checked').length > 0;
            };

            __webpack_public_path__ = window.ll_script.base;
            import(/* webpackChunkName: "findinstore" */ './product/rf_findinstore').then((findinstore) => {
                let fs = findinstore.default;
                fs.run();
                $('.persButtonPdpPers').hide();
                $('.findinstore-wrapper').data('type', 'Pickup');
                $('.find-in-store-size-select-btn').hide();
                fs.launch();
            });

            if ($('.page[data-action="Search-Show"]').length > 0) {
                $('body').trigger('find-in-store-size-select-btn:click', e)
            } else if (isSizeSelected()) {
                $('body').trigger('product:moreInfoToggle', 'find_in_store');
            } else {
                $('body').trigger('product:find_in_store_soldout', e.currentTarget);
            }
        });
    }

    $('body').on('click', '.js-modal-made-in', function (e) {
        e.preventDefault();
        const htmlContent = $('.js-modal-made-in-container').html();
        var modalContent = $('#' + ($(this).data('modal'))).html();
        // create and open confirmation modal
        const modal = newModalFromString(htmlContent, false);
        modal.open();
        modal.setContent(modalContent);
        $(modal.modalBox).addClass('made-in-modal');
        $(modal.modalBox)
            .find('.close')
            .on('click', function (e) {
                modal.close();
            });

        $('.js-inside-close-modal').on('click', function (e) {
            e.preventDefault();
            modal.close();
        });

        $('[data-dismiss="modalBigContent"]').on('click', function (e) {
            e.preventDefault();
            modal.close();
        });
    });
    if (Foundation.MediaQuery.is('medium')) {
        $('body').on('click', '.productImageCarouselItem', function (e) {
            $('html').css({ 'overflow-y': 'hidden' });
            if (window.devicePixelRatio === 1.5) {
                $('.next').css({ right: '64px' });
            } else if (window.devicePixelRatio === 1.25) {
                $('.next').css({ right: '159px' });
            } else if (window.devicePixelRatio === 1) {
                $('.next').css({ right: '352px' });
            }
            if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
                $('.next').css({ right: '113px' });
            }
            if (window.devicePixelRatio === 2) {
                $('.next').css({ right: '240px' });
            }
            var n = parseInt($(this).attr('data-index')) + 1;
            var modal = document.getElementById('zoom-slider');
            modal.style.display = 'flex';
            showSlides(slideIndex = n);
        });
        $('body').on('click', '.zoom', function (e) {
            $('html').css({ 'overflow-y': '' });
            var modal = document.getElementById('zoom-slider');
            modal.style.display = 'none';
        });
        $('body').on('mousemove', '.zoom', function (e) {
            var positionTopZoom = (-e.pageY + $(document).scrollTop());
            var farFromTop = positionTopZoom * (($('.zoom').height() - window.innerHeight) / window.innerHeight);
            $('.zoom').css('top', Math.floor(farFromTop) + 'px');
        });
    }
    if ($('.page[data-action="Product-Show"]').length > 0 && !Foundation.MediaQuery.is('medium')) {
        const addToCartCTA = $('.add-to-cart-actions .add-to-cart-container');
        const personalizationCTA = $('.fnPersButtonContainer');
        const addToCartStickyBar = $('.add-to-cart-sticky-bar').addClass('bottom-fixed-bar');

        // there is a bug where personalization button is copied to mobile device even when personalization is not available
        if (!personalizationCTA.hasClass('d-none')) {
            // copy 'add to cart' and 'personalization'
            $(addToCartStickyBar).find('.add-to-cart-sticky-bar-buttons').html($(addToCartCTA).html() + $(personalizationCTA).html()).addClass('cc-buttons-inline-sticky');
        } else {
            // copy 'add to cart'
            $(addToCartStickyBar).find('.add-to-cart-sticky-bar-buttons').html($(addToCartCTA).html());
        }

        $(addToCartStickyBar).find('.add-to-cart-sticky-bar-messaging').html($('.klarnaWidgetContainer').parent().html());
        window.addEventListener('scroll', onScrollFunction);
    }

    masterProduct();
    modalQuickAdd();

    const $tooltip = $('<div class="dynamic-tooltip"></div>').appendTo("body");

    $("body")
        .on("mouseenter", ".boolean-field-wrapper", function (e) {
            const html = $(this).find(".tooltip-stock-wrapper").html();
            if (!html) return;

            $tooltip.html(html).show();

            const trigger = e.currentTarget.getBoundingClientRect();
            const tooltip = $tooltip[0].getBoundingClientRect();
            const gap = 8;

            const top = trigger.bottom + window.scrollY + gap;

            const left = Math.min(
                Math.max(
                    trigger.left +
                        window.scrollX +
                        trigger.width / 2 -
                        tooltip.width / 2,
                    0,
                ),
                window.innerWidth - tooltip.width,
            );

            $tooltip.css({ top, left });
        })
        .on("mouseleave", ".boolean-field-wrapper", () => $tooltip.hide());
});

function masterProduct() {
    var selectedProductColor = $('.color-variation .selected');
    var productColor = $('.color-variation');
    if (selectedProductColor.length === 0 && productColor.length > 0) {
        productColor.first().trigger('click');
    }
}

function updateStickyTop () {
    const viewportHeight = window.innerHeight;
    const rightBar = document.querySelector('.descriptionSidebar__container');
    const header = document.querySelector('.main-header');

    if (rightBar && header) {
        const overflow = rightBar.offsetHeight - viewportHeight + header.offsetHeight;
        const topOffset = overflow > 0 ? overflow : 0;
        document.documentElement.style.setProperty('--sticky-top', `${-topOffset}px`);
    }
}

function showSlides(n) {
    var i;
    var slides = document.getElementsByClassName('mySlides');
    var length = slides.length;
    for (i = 0; i < slides.length; i++) {
        if ($($('.mySlides')[i]).children().hasClass('hidden')) {
            length--;
        }
    }
    if (n > length) {
        slideIndex = 1;
    }
    if (n < 1) {
        slideIndex = length;
    }
    for (i = 0; i < length; i++) {
        slides[i].style.display = 'none';
    }
    slides[slideIndex - 1].style.display = 'block';
}

// Modal Smart Gift Rules
$('.js-smart-gift-rules').on('click', function (e) {
    e.preventDefault();
    const htmlContent = $($(this).data('target')).html();
    // create and open confirmation modal
    const modalBigContent = newModalFromString(htmlContent, false);
    modalBigContent.setContent(document.querySelector('.js-smart-gift-rules-modal').innerHTML);
    $('.tingle-modal').addClass('wrapperModal');
    $('.wrapperModal').addClass('smartGiftModal');
    modalBigContent.open();
    $(modalBigContent.modalBox)
        .find('.close')
        .on('click', function (e) {
            modalBigContent.close();
        });

    $('.js-inside-close-modal').on('click', function (e) {
        e.preventDefault();
        modalBigContent.close();
    });

    $('[data-dismiss="modalBigContent"]').on('click', function (e) {
        e.preventDefault();
        modalBigContent.close();
    });
});
